<template>
  <div>
    <div class="logo"><img :alt="$t('seisoka')" :src="footerLogo"/></div>
    <table class="info" :class="{en: $i18n.locale === 'en'}">
      <tbody>
        <tr>
          <th>{{ $t('addressTitle') }}</th><td>{{ $t('address') }}</td>
        </tr>
        <tr>
          <th>{{ $t('telTitle') }}</th><td>{{ $t('tel') }}</td>
        </tr>
        <tr>
          <th>{{ $t('businessHoursTitle') }}</th><td v-html="$t('businessHours')">12:00～14:30<br/>17:30～23:00</td>
        </tr>
        <tr>
          <th>{{ $t('holidaysTitle') }}</th><td>{{ $t('sunday') }}</td>
        </tr>
      </tbody>
    </table>
    <div class="description">
      {{ $t('howToGo') }}<br><br>
    </div>
    <div class="map">
      <img v-if="$i18n.locale === 'ja'" src="@/assets/image/map.svg" alt="地図">
      <img v-else-if="$i18n.locale === 'en'" src="@/assets/image/map-en.svg" alt="map">
    </div>
  </div>
</template>

<script>
import logo from "@/assets/logo/logo.svg";

export default {
  computed: {
    footerLogo() {
      return logo;
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  margin-bottom: 35px;
  > img {
    width: 90px;
  }
}

h1 {
  margin: 0 0 50px 0;
}
.info {
  font-size: 12px;
  margin-bottom: 42px;
  th, td {
    text-align: left;
    vertical-align: top;
    padding: 3px 47px 3px 0;
  }
}
.description {
  font-size: 11px;
  margin-bottom: 10px;
}
.map img {
  width: 80%;
}
@media (max-width: $mobile-vw - 1) {
  .map img {
    max-width: 270px;
  }
}

@media (min-width: $mobile-vw) {
  .logo {
    font-size: 27px;
    margin: 186px 0 16px 0;
    > img {
      width: 93px;
    }
  }

  .info {
    font-size: 19px;
    th, td {
      text-align: left;
      vertical-align: middle;
      padding: 5px 8px 5px 0;
    }
    &.en th {
      padding: 5px 45px 5px 0;
    }
  }
  .description {
    font-size: 15px;
    margin: 56px 0 47px 0;
  }
  .map {
    margin-bottom: 50px;
    img {
      width: 478px;
    }
  }
}
</style>